module.exports = __webpack_public_path__ + "files/afbda51b3e8acb060d6c2f5d26b14f72.svg";